import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { SpaTreatment } from './SpaTreatment';
import { SpaTreatmentDetailV2 } from './v2';

export const SpaTreatmentVersion: FC<any> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <SpaTreatmentDetailV2 {...props} />;
  return <SpaTreatment {...props} />;
};
